"use client";
import "./team.scss";

import { Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "@/components/general/section";

import { SectionTitle } from "../general/section-title/section-title";
const Team = () => {
    const { t } = useTranslation();

    return (
        <Section variant="purple-pink" className="team-section">
            <SectionTitle title={t("about.title")} subTitle={t("about.subtitle")} isH1 />
            <div className="team-text">
                <Text mt="md">{t("about.description")}</Text>
                <Text>{t("about.description2")}</Text>
                <Text>
                    {t("about.description3")}{" "}
                    <a href="https://christian.busshoff.net/" target="_blank" rel="noreferrer">
                        <strong>Christian Bußhoff</strong>
                    </a>
                    {t("about.description4")}
                </Text>
                <Text>{t("about.description5")}</Text>
            </div>
        </Section>
    );
};

export default Team;
